var _excluded = ["main", "aside"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import IsDarkModeContext from "../../../../../../contexts/IsDarkModeContext";
import OnColorContext from "../../../../../../contexts/OnColorContext";
import breakpoint from "../../../../../../utils/breakpoint";
import getColor from "../../../../../../utils/getColor";
import space from "../../../../../../utils/space";
import { breakpointValue } from "../../settings";
export var mainBackgroundColor = "backgroundLight";
export var asideBackgroundColor = "background";
export var mainBackgroundColorDarkMode = "backgroundBlack";
export var asideBackgroundColorDarkMode = "backgroundDarker";
var horizontalPaddingSpace = 6;
export var horizontalPaddingSpaceOnDesktop = 4;
var Wrapper = styled.div.withConfig({
  componentId: "sc-16xsymm-0"
})(function (_ref) {
  var $background = _ref.$background,
    theme = _ref.theme;
  return css(["background:", ";"], getColor(theme, $background));
});
var Main = styled.div.withConfig({
  componentId: "sc-16xsymm-1"
})(["padding:", " ", ";", "{padding-right:", ";padding-left:", ";}"], space(5), space(horizontalPaddingSpace), breakpoint(breakpointValue), space(horizontalPaddingSpaceOnDesktop), space(horizontalPaddingSpaceOnDesktop));
var Aside = styled.div.withConfig({
  componentId: "sc-16xsymm-2"
})(function (_ref2) {
  var $isDarkMode = _ref2.$isDarkMode,
    $background = _ref2.$background,
    theme = _ref2.theme;
  return css(["padding:", " ", ";background:", ";", "{padding-right:", ";padding-left:", ";}"], space(3), space(horizontalPaddingSpace), $isDarkMode ? "#1B1B1B" : getColor(theme, $background), breakpoint(breakpointValue), space(horizontalPaddingSpaceOnDesktop), space(horizontalPaddingSpaceOnDesktop));
});
function DropdownOrg(_ref3) {
  var main = _ref3.main,
    aside = _ref3.aside,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var isDarkMode = useContext(IsDarkModeContext);
  var mainColor = isDarkMode ? mainBackgroundColorDarkMode : mainBackgroundColor;
  var asideColor = isDarkMode ? asideBackgroundColorDarkMode : asideBackgroundColor;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $background: mainColor
  }, restProps), /*#__PURE__*/React.createElement(Main, null, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: mainColor
  }, main)), aside ? /*#__PURE__*/React.createElement(Aside, {
    $isDarkMode: isDarkMode,
    $background: asideColor
  }, /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: asideColor
  }, aside)) : null);
}
export default DropdownOrg;